import React, { useCallback } from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import styled, { DefaultTheme } from 'styled-components';
import { ActionMeta, Props, Theme } from 'react-select';
import { useAssessmentsQuery } from 'src/graphql/_generated';

const StyledSelect = styled(CSelect)`
  .cydea-select__control {
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.prussianBlue};
  }
`;

interface AssessmentSelectProps extends Omit<Props<{ label: string; value: string }>, 'value'> {
  theme?: Theme & DefaultTheme;
  value?: string;
  onChange?: (value: { label: string; value: string }, meta: ActionMeta<any>) => void;
  placeholder?: string;
}

export const AssessmentSelect: React.FC<AssessmentSelectProps> = ({
  value,
  placeholder = 'Select Assessment',
  ...other
}) => {
  const { data } = useAssessmentsQuery();

  const options =
    data?.assessments.map((el) => {
      return {
        label: el.name,
        value: el.id as string,
      };
    }) || [];

  const getOptionValue = useCallback((option: any) => option.value, []);
  return (
    <div data-cy="assessment-select">
      <StyledSelect
        value={options.find((el) => el.value === value)}
        getOptionValue={getOptionValue}
        placeholder={placeholder}
        options={options}
        {...other}
      />
      {other.error && other.helperText && <Error>{other.helperText}</Error>}
    </div>
  );
};
